import {
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type {
  PriorityInboxKind,
  PriorityInboxStatus,
  PriorityInboxThread,
} from "@circle-react/types/PriorityInboxThread";

export interface PriorityInboxThreadsResponse {
  count: number;
  has_next_page: boolean;
  page: number;
  page_count: number;
  per_page: number;
  records: PriorityInboxThread[];
}

const PER_PAGE = 20;

interface ListParams {
  kinds?: PriorityInboxKind[];
  page?: number;
  status?: PriorityInboxStatus;
}

const list = ({ page = 1, status, kinds }: ListParams = {}) =>
  reactQueryGet<PriorityInboxThreadsResponse>(
    internalApi.priorityInbox.threads({
      params: {
        page,
        per_page: PER_PAGE,
        ...(status ? { status } : {}),
        ...Object.fromEntries((kinds ?? []).map(kind => [kind, 1])),
      },
    }),
  );

export interface UnreadCountResponse {
  unread_count: number;
}

const unreadCount = () =>
  reactQueryGet<UnreadCountResponse>(internalApi.priorityInbox.unreadCount());

const solve = ({ id }: { id: number }) =>
  reactQueryPost<void>(internalApi.priorityInbox.solve({ id }));

const unsolve = ({ id }: { id: number }) =>
  reactQueryPost<void>(internalApi.priorityInbox.unsolve({ id }));

const dismiss = ({ id }: { id: number }) =>
  reactQueryPost<void>(internalApi.priorityInbox.dismiss({ id }));

const markRead = (id: number) =>
  reactQueryPatch(internalApi.priorityInbox.read({ id }));

export const priorityInboxApi = {
  dismiss,
  list,
  markRead,
  solve,
  unreadCount,
  unsolve,
};
